<div class="transaction-history-shell">
  <div class="container fw-b wrapper-content">
    <app-linker-route
      [headingName]="headingName"
      [linkerRouteItems]="linkerRouteItems"
    ></app-linker-route>
  </div>

  <section class="container transaction-hero">
    <div class="hero-container-card">
      <div class="hero-cards-wrapper">
        <div class="hero-stat-card wallet-card">
          <div class="card-accent-strip wallet-accent"></div>
          <div class="card-content">
            <div class="card-icon-wrapper wallet-icon">
              <i class="fa fa-credit-card" aria-hidden="true"></i>
            </div>
            <p class="stat-amount">
              {{
                (wallet?.walletAmount &&
                  getPrice(wallet?.walletAmount | currency : 'ZAR' : 'R')) ||
                  'R 0.00'
              }}
            </p>
            <label class="stat-label">WALLET BALANCE</label>
          </div>
        </div>
        <div class="hero-stat-card earning-card">
          <div class="card-accent-strip earning-accent"></div>
          <div class="card-content">
            <div class="card-icon-wrapper earning-icon">
              <i class="fa fa-line-chart" aria-hidden="true"></i>
            </div>
            <p class="stat-amount">
              {{
                totalEarning !== null && totalEarning !== undefined
                  ? getPrice(totalEarning | currency : 'ZAR' : 'R')
                  : 'R 0.00'
              }}
            </p>
            <label class="stat-label">TOTAL EARNING</label>
          </div>
        </div>
        <div class="hero-stat-card commission-card">
          <div class="card-accent-strip commission-accent"></div>
          <div class="card-content">
            <div class="card-icon-wrapper commission-icon">
              <i class="fa fa-money" aria-hidden="true"></i>
            </div>
            <p class="stat-amount">
              {{
                totalCommissionPaid !== null && totalCommissionPaid !== undefined
                  ? getPrice(totalCommissionPaid | currency : 'ZAR' : 'R')
                  : 'R 0.00'
              }}
            </p>
            <label class="stat-label">TOTAL COMMISSION PAID</label>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="container transaction-table-section">
    <article class="transaction-table-card">
      <div class="table-header">
        <div>
          <p class="section-eyebrow">Transactions</p>
          <h2>Transaction activity</h2>
        </div>
        <span class="badge-counter">{{ count || 0 }} records</span>
      </div>

      <div class="table-responsive">
        <table class="table modern-table">
          <thead>
            <tr>
              <th scope="col">Serial No.</th>
              <th scope="col">From Wallet</th>
              <th scope="col">To Wallet</th>
              <th scope="col">Amount in R</th>
              <th scope="col">Order Status</th>
              <th scope="col">Order Date</th>
              <th scope="col">Order Id</th>
              <th scope="col">Customer Name</th>
              <th scope="col">Customer Email</th>
              <th scope="col">Txn. Status</th>
              <th scope="col">Txn. Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of orderList
                  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: count
                      };
                let i = index
              "
            >
              <td data-label="Serial No.">{{ 10 * (currentPage - 1) + i + 1 }}</td>
              <td data-label="From Wallet">
                <div class="wallet-tag">
                  <ng-container *ngIf="item?.fromWalletType == 'OZW'">
                    <span class="wallet-name">OZOW Payment</span>
                    <span class="wallet-type">({{item?.fromWalletType}})</span>
                  </ng-container>
                  <ng-container *ngIf="item?.fromWalletType == 'PFW'">
                    <span class="wallet-name">PAY FAST Payment</span>
                    <span class="wallet-type">({{item?.fromWalletType}})</span>
                  </ng-container>
                  <ng-container *ngIf="item?.fromWalletType != 'OZW' && 
                  item?.fromWalletType != 'PFW' &&
                  item?.fromWalletType != 'OW'">
                    <span class="wallet-name">{{ item?.fromUser?.firstName || '--' }} {{ item?.fromUser?.lastName }}</span>
                    <span class="wallet-type">({{item?.fromWalletType}})</span>
                  </ng-container>
                  <ng-container *ngIf="
                  item?.fromWalletType != 'OZW' && 
                  item?.fromWalletType != 'PFW' &&
                  item?.fromWalletType == 'OW'">
                    <span class="wallet-name">{{item?.orderReferenceId?.userId?.firstName || '--'}} {{ item?.orderReferenceId?.userId?.lastName }}</span>
                    <span class="wallet-type">({{item?.fromWalletType}})</span>
                  </ng-container>
                </div>
              </td>
              <td data-label="To Wallet">
                <div class="wallet-tag">
                  <ng-container *ngIf="item?.toWalletType != 'OW'">
                    <span class="wallet-name">{{ item?.toUser?.firstName || '--' }} {{ item?.toUser?.lastName }}</span>
                    <span class="wallet-type">({{item?.toWalletType}})</span>
                  </ng-container>
                  <ng-container *ngIf="item?.toWalletType == 'OW'">
                    <span class="wallet-name">{{item?.orderReferenceId?.userId?.firstName || '--'}} {{ item?.orderReferenceId?.userId?.lastName }}</span>
                    <span class="wallet-type">({{item?.toWalletType}})</span>
                  </ng-container>
                </div>
              </td>
              <td
                data-label="Amount in R"
                [ngClass]="item?.isCommission || item?.fromUser?._id == myId ? 'text-theme-negative' : 'text-success'"
              >
                {{item?.isCommission ||  item?.fromUser?._id == myId ? '-' : '+' }} {{ item?.transactionAmount && getPrice(item?.transactionAmount | currency:"ZAR":"R") ||'--'}}
              </td>
              <td data-label="Order Status">{{ item?.orderReferenceId?.orderStatus || '--' }}</td>
              <td data-label="Order Date">{{ item?.orderReferenceId?.createdAt | date : "medium" }}</td>
              <td data-label="Order Id">{{ item?.orderReferenceId?.orderId || '--' }}</td>
              <td data-label="Customer Name">{{ item?.orderReferenceId?.userId?.firstName || '--'}} {{ item?.orderReferenceId?.userId?.lastName }}</td>
              <td data-label="Customer Email">{{ item?.orderReferenceId?.userId?.email || '--'}} </td>
              <td data-label="Txn. Status">
                <span
                  class="status-chip"
                  [ngClass]="[
                    item?.transactionStatus,
                    (item?.transactionStatus || '').toLowerCase()
                  ]"
                >
                  {{ item?.transactionStatus }}
                </span>
              </td>
              <td data-label="Txn. Date">{{ item?.createdAt | date : "medium" || "--" }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        *ngIf="orderList?.length === 0 && !isLoading"
        class="empty-state text-center"
      >
        <p class="text-muted mb-3">
          No transactions yet. Once transactions are processed, your transaction history will appear here.
        </p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="bi bi-receipt"
          width="58"
          height="58"
          fill="lightgray"
          viewBox="0 0 16 16"
        >
          <path
            d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27m.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0z"
          />
          <path
            d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
          />
        </svg>
      </div>

      <app-table-loader
        *ngIf="isLoading"
        [isTable]="'TABLE'"
        [isLoading]="isLoading"
        [notFoundData]="notFoundData"
        [colspan]="11"
        [isWidth]="'55px'"
      >
      </app-table-loader>

      <div class="transaction-table-footer" *ngIf="count > 10">
        <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
      </div>
    </article>
  </section>
</div>